// extracted by mini-css-extract-plugin
export default {"button":"kj-z","reviewSort":"lj-z"};